import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lowercaseExceptMu',
})
export class LowercaseExceptMuPipe implements PipeTransform {
  transform(value: string): string {
    return value === 'MU' ? value : value.toLowerCase();
  }
}
